import { STATUS_TABS, STATUS_TAB_LABEL, type StatusTab } from '../../lib/merchant/status';

/**
 * Mockup segmented status filter. Selected tab is eerie-black/pink; the rest
 * are transparent/gray. Per-tab counts (when provided) render dimmed after
 * the label. Iterates `tabs` (default: the canonical `STATUS_TABS` order —
 * shop lists pass `SHOP_STATUS_TABS` to gain the "Aguard. ativação" tab).
 */
export function StatusTabs({
  value,
  counts,
  onChange,
  tabs = STATUS_TABS,
}: {
  value: StatusTab;
  counts: Partial<Record<StatusTab, number>>;
  onChange: (t: StatusTab) => void;
  tabs?: readonly StatusTab[];
}): JSX.Element {
  return (
    <div className="flex gap-1" role="tablist">
      {tabs.map((tab) => {
        const selected = value === tab;
        const count = counts[tab];
        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(tab)}
            className={`inline-flex items-center gap-1.5 rounded-[var(--m-r-pill)] px-3.5 py-2 text-[13px] font-bold uppercase tracking-[0.04em] transition-colors ${
              selected
                ? 'bg-[var(--m-bg-inverse)] text-[var(--m-bg-alt)]'
                : 'bg-transparent text-[var(--m-fg-muted)] hover:text-[var(--m-fg)]'
            }`}
          >
            {STATUS_TAB_LABEL[tab]}
            {count != null && <span className="opacity-70">{count}</span>}
          </button>
        );
      })}
    </div>
  );
}
